import { FEATURE_FLAGS } from '../../../../featureFlags';
import { frontendURL } from '../../../../helper/URLHelper';

import SettingsWrapper from '../SettingsWrapper.vue';
import Index from './Index.vue';

const meta = {
  featureFlag: FEATURE_FLAGS.LEAD_SCORE,
  permissions: ['administrator'],
};

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/lead-score'),
      component: SettingsWrapper,
      props: {},
      children: [
        {
          path: '',
          name: 'lead_score_wrapper',
          meta,
          redirect: to => {
            return { name: 'lead_score_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'lead_score_list',
          meta,
          component: Index,
        },
      ],
    },
  ],
};
